import { render, staticRenderFns } from "./OrderPrintItem.vue?vue&type=template&id=c1071dae&scoped=true&"
import script from "./OrderPrintItem.vue?vue&type=script&lang=js&"
export * from "./OrderPrintItem.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css?vue&type=style&index=0&id=c1071dae&scoped=true&lang=css&"
import style1 from "./OrderPrintItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1071dae",
  null
  
)

export default component.exports